import React, { useState } from 'react'

const imgHelpCircle = '/icon/help-circle.svg'
const imgMinusSign = '/icon/minus-sign.svg'
const imgPlusSign = '/icon/plus-sign.svg'
const imgGroup1171275030 = '/faq-cta-img.svg'

const faqs = [
  {
    q: 'What is your 15-day money-back guarantee?',
    a: 'We offer a 15-day money-back guarantee on all paid plans. If you\'re not satisfied with Notifyer for any reason within the first 15 days of your subscription, contact our support team and we\'ll provide a full refund—no questions asked. This guarantee applies to your first subscription payment and gives you peace of mind to try our platform risk-free.',
  },
  {
    q: 'Do I use my own WhatsApp number or a verified bot number?',
    a: 'You use your own WhatsApp number. Notifyer connects to your existing WhatsApp Business account, allowing two-way conversations. Recipients can reply directly to your number, and you can respond through our mobile apps or web interface.',
  },
  {
    q: 'What features are available in the mobile apps?',
    a: 'Our iOS and Android apps include push notifications, real-time chat management, team collaboration tools, analytics dashboard, and bulk messaging capabilities. You can manage all your WhatsApp communications on the go.',
  },
  {
    q: 'How do sequences and stop-on-reply work?',
    a: 'Sequences work like cold email tools - you can set up automated follow-up messages. The system automatically stops sending messages to a contact once they reply, preventing spam and maintaining conversation quality.',
  },
  {
    q: 'Can I use Twilio numbers with Notifyer?',
    a: 'Yes, Twilio numbers are supported if properly provisioned. We provide a 5-minute verification process to connect your Twilio number. Contact support for assistance with Twilio integration.',
  },
  {
    q: 'Why is the Recurring Plan recommended over Single-Use?',
    a: 'The Recurring Plan offers unlimited messages per contact, two-way conversations, team management, advanced analytics, and full automation capabilities. Single-Use is limited to 5 messages per contact with no reply functionality.',
  },
  {
    q: 'What does the "Try with 2 numbers" free option include?',
    a: 'The free option allows you to test Notifyer with up to 2 phone numbers without a subscription. You get full access to all features for 3 days, then can upgrade to a paid plan or continue with limited functionality.',
  },
  {
    q: 'Can I switch between plans?',
    a: 'Yes, you can upgrade or downgrade your plan at any time through our support team. Changes take effect immediately, and we\'ll prorate any billing differences.',
  },
  {
    q: 'How do I set up an AI chatbot?',
    a: 'AI chatbots are created through integrations with Zapier, Make, or n8n. We provide detailed tutorials and templates to help you build intelligent automated responses. Check our documentation for step-by-step guides.',
  },
  {
    q: 'What do I need to connect my WhatsApp account?',
    a: 'You need a Meta Business Manager account, access to your phone number for SMS/call verification, and a WhatsApp Business account. Some countries have restrictions - check our country list for exceptions.',
  },
  {
    q: 'How long does the connection process take?',
    a: 'Typical connection takes 5-10 minutes. If it fails, you\'ll receive clear error messages with retry options. Our support team is available via Zoom for complex setups.',
  },
  {
    q: 'Do I need WhatsApp template approval?',
    a: 'Yes, outbound messages require pre-approved templates from Meta. We provide guidance on template creation and approval. For inbound conversations, you can respond freely within 24 hours.',
  },
]

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0)

  return (
    <section id="faqs" className="scroll-mt-20 bg-white px-4 py-10 sm:px-6 sm:py-12 lg:px-[100px] lg:py-16">
      <div className="mx-auto grid max-w-[1240px] grid-cols-1 gap-10 lg:grid-cols-[auto_1fr] lg:items-start">
        {/* Left: heading */}
        <div className="w-full max-w-[480px] space-y-4 sm:space-y-5">
          <div className="grid grid-cols-[auto_1fr] items-center gap-2 rounded-full bg-[#fafafa] px-3 py-2 text-[12px] font-medium uppercase tracking-[0.28px] text-[#1c2329] shadow-[inset_0px_1px_1px_rgba(26,32,50,0.1),inset_0px_1px_2px_rgba(26,32,50,0.05)] w-fit sm:px-4 sm:text-[13px]">
            <img src={imgHelpCircle} alt="" className="h-6 w-6" />
            <span>FAQs</span>
          </div>
          <h2 className="text-[30px] font-semibold leading-[1.2] tracking-[-0.9px] text-[#1c2329] sm:text-[38px] sm:tracking-[-1.1px] md:text-[46px] md:leading-[1.2] lg:text-[48px] lg:tracking-[-1.2px]">
            Frequently
            <br />
            asked questions
          </h2>
          <p className="text-[15px] leading-[1.7] tracking-[-0.45px] text-[#656f68] sm:text-[16px] sm:tracking-[-0.5px]">
            Find answers to common questions about Notifyer and WhatsApp automation.
          </p>
        </div>

        {/* Right: accordion list */}
        <div className="flex-1 space-y-3 rounded-[16px] border border-[#f2f3f3] bg-[#fafaf9] p-2 sm:p-3">
          {faqs.map((item, idx) => {
            const open = openIndex === idx
            return (
              <div
                key={item.q}
                className="rounded-[12px] border border-[#f3f3f2] bg-white px-4 py-4 shadow-[0px_4px_8px_-2px_rgba(16,24,40,0.08)] sm:px-5 sm:py-5"
              >
                <div className="grid grid-cols-[1fr_auto] items-center gap-4">
                  <h3 className="text-[17px] font-semibold tracking-[-0.55px] text-[#1c2329] sm:text-[20px] sm:tracking-[-0.6px]">
                    {item.q}
                  </h3>
                  <button
                    onClick={() => setOpenIndex(open ? -1 : idx)}
                    className="grid h-10 w-10 place-items-center rounded-full bg-[#1c2329] transition hover:opacity-90 sm:h-11 sm:w-11"
                    aria-label={open ? 'Collapse' : 'Expand'}
                  >
                    <img src={open ? imgMinusSign : imgPlusSign} alt="" className="h-5 w-5 sm:h-6 sm:w-6" />
                  </button>
                </div>
                {open && (
                  <p className="mt-3 text-[15px] leading-[1.7] text-[#656f68] sm:mt-4 sm:text-[16px]">
                    {item.a || 'Details coming soon.'}
                  </p>
                )}
              </div>
            )
          })}

          {/* Contact support card */}
          <div className="relative overflow-hidden rounded-[12px] border border-dashed border-[rgba(28,35,41,0.3)] bg-white px-4 py-5 sm:px-5 sm:py-6">
            <img 
              src={imgGroup1171275030} 
              alt="" 
              className="hidden pointer-events-none absolute right-0 top-0 h-full object-contain opacity-50 sm:block" 
              style={{ width: 'auto', maxWidth: '40%', height: '100%', objectPosition: 'right center' }}
            />
            <div className="relative z-10 grid grid-cols-1 gap-3 sm:grid-cols-[1fr_auto] sm:items-center sm:gap-4">
              <div>
                <h4 className="text-[17px] font-semibold tracking-[-0.55px] text-[#1c2329] sm:text-[18px] sm:tracking-[-0.6px]">
                  Still have more questions?
                </h4>
                <p className="text-[15px] leading-[1.7] text-[#656f68] sm:text-[16px]">We're here to help. Contact us for assistance.</p>
              </div>
              <button 
                onClick={() => window.open('https://wa.me/+13476861478?text=Hi%20WhatsAble%20team,%20I%20need%20help%20with%20your%20WhatsApp%20automation%20service', '_blank')}
                className="w-full whitespace-nowrap rounded-full bg-[#1c2329] px-6 py-3 text-[15px] font-semibold tracking-[-0.4px] text-white shadow-[0px_4px_8px_rgba(36,196,211,0.1)] sm:w-[170px]"
              >
                Contact Support
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FAQ

